(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-stats"] && !Shopify.designMode) return;
  try {
    
  class AboutStatsCountUp {
    constructor(section) {
      this.section = section;
      this.numbers = Array.from(section.querySelectorAll("[data-countup-number]"));
      this.duration = Number(section.dataset.countDuration) || 5000;
      this.observer = null;
      this.handleIntersect = this.handleIntersect.bind(this);
      this.init();
    }

    init() {
      if (!this.numbers.length) return;

      if (!("IntersectionObserver" in window)) {
        this.numbers.forEach((number) => this.animate(number));
        return;
      }

      this.observer = new IntersectionObserver(this.handleIntersect, {
        root: null,
        rootMargin: "0px 0px",
        threshold: 0.2,
      });

      this.numbers.forEach((number) => this.observer.observe(number));
    }

    handleIntersect(entries) {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        this.animate(entry.target);
        if (this.observer) {
          this.observer.unobserve(entry.target);
        }
      });
    }

    animate(element) {
      if (element.dataset.countupComplete === "true") return;

      const start = Number(element.dataset.startNumber || 0);
      const end = Number(element.dataset.endNumber || 0);
      const decimals = this.countDecimals(start, end);

      if (start === end) {
        element.textContent = this.formatNumber(end, decimals);
        element.dataset.countupComplete = "true";
        return;
      }

      let startTimestamp = null;

      const step = (timestamp) => {
        if (!startTimestamp) startTimestamp = timestamp;
        const progress = Math.min((timestamp - startTimestamp) / this.duration, 1);
        const easedProgress = 1 - Math.pow(1 - progress, 5);
        const currentValue = start + (end - start) * easedProgress;

        element.textContent = this.formatNumber(currentValue, decimals);

        if (progress < 1) {
          window.requestAnimationFrame(step);
        } else {
          element.textContent = this.formatNumber(end, decimals);
          element.dataset.countupComplete = "true";
        }
      };

      window.requestAnimationFrame(step);
    }

    countDecimals(start, end) {
      const values = [start, end];
      return values.reduce((maxDecimals, value) => {
        if (Math.floor(value) === value) return maxDecimals;
        const decimalPart = value.toString().split(".")[1];
        return Math.max(maxDecimals, decimalPart ? decimalPart.length : 0);
      }, 0);
    }

    formatNumber(value, decimals) {
      return value.toLocaleString("en-US", {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
      });
    }
  }

  const initAboutStatsCountUp = (container = document) => {
    const sections = container.matches?.("[data-about-stats-section]")
      ? [container]
      : Array.from(container.querySelectorAll("[data-about-stats-section]"));

    sections.forEach((section) => {
      if (window.Shopify && Shopify.designMode) {
        section.classList.add("section-about-stats--editor");
      }

      if (section.dataset.countupInitialized === "true") return;
      section.dataset.countupInitialized = "true";
      new AboutStatsCountUp(section);
    });
  };

  initAboutStatsCountUp();
  document.addEventListener("DOMContentLoaded", () => initAboutStatsCountUp());
  document.addEventListener("shopify:section:load", (event) => initAboutStatsCountUp(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommend-custom"] && !Shopify.designMode) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  var section = document.querySelector(".product-custom-recommendations");
  if (!section) return;
  
  var currentProductId = section.dataset.productId;
  var url = section.dataset.url;
  
  var xhr = new XMLHttpRequest();
  xhr.open("GET", url);
  xhr.onload = function() {
    if (xhr.status >= 200 && xhr.status < 300) {
      var tempDiv = document.createElement("div");
      tempDiv.innerHTML = xhr.response;
      
      var recommendedItems = tempDiv.querySelectorAll(".lens-product-block");
      var listContainer = section.querySelector(".lens-list-container");

      recommendedItems.forEach(function(item) {
        var itemId = item.dataset.productId;
        
        // 1. 현재 제품과 ID가 같으면 추가 안 함 (중복 방지)
        // 2. 이미 리스트에 존재하는 ID여도 추가 안 함
        var isDuplicate = listContainer.querySelector('.lens-product-block[data-product-id="' + itemId + '"]');
        
        if (itemId !== currentProductId && !isDuplicate) {
           listContainer.appendChild(item);
        }
      });
    }
  };
  xhr.send();
};

document.addEventListener("shopify:section:load", loadProductRecommendationsIntoSection);
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      theme.ProductBlockManager.loadImages(productRecommendationsSection);
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
